import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import config from '../config';
import { getCookie } from '../functions/functions';

import '../css/news.css';

class PollOption extends Component {
	render() {
		const { option, totalVotes, userVotedOptionId, onVote, expired } = this.props;
		const hasVoted = userVotedOptionId !== null && userVotedOptionId !== undefined;
		const isSelected = userVotedOptionId === option.optionId;
		const pct = totalVotes > 0 ? Math.round((option.votes / totalVotes) * 100) : 0;

		return (
			<div
				className={`news-poll-option ${hasVoted ? 'voted' : ''} ${isSelected ? 'selected' : ''} ${expired ? 'disabled' : ''}`}
				onClick={() => !hasVoted && !expired && onVote(option.optionId)}
			>
				{hasVoted && (
					<div className="news-poll-option-bar" style={{ width: `${pct}%` }} />
				)}
				<span className="news-poll-option-text">{option.text}</span>
				{hasVoted && (
					<>
						<span className="news-poll-option-votes">{option.votes} vote{option.votes !== 1 ? 's' : ''}</span>
						<span className="news-poll-option-pct">{pct}%</span>
					</>
				)}
			</div>
		);
	}
}

class Article extends Component {
	render() {
		const { article, onVote } = this.props;
		const { title, content, image, read, createdAt, cta, poll } = article;
		const totalVotes = poll ? poll.options.reduce((sum, o) => sum + o.votes, 0) : 0;
		const expired = poll && poll.expiresAt && new Date() > new Date(poll.expiresAt);

		return (
			<div className={`news-article ${!read ? 'unread' : ''}`}>
				<p className="news-article-date">{moment(createdAt).format('DD/MM/YYYY')}</p>
				<h3 className="news-article-title">{title}</h3>
				{image && (
					<img
						src={image}
						alt={title}
						className="news-article-image"
						onClick={() => window.open(image, '_blank')}
					/>
				)}
				<p className="news-article-content">{content}</p>
				{cta && (
					<a href={cta.link} target="_blank" rel="noopener noreferrer" className="news-article-cta">
						{cta.title}
					</a>
				)}
				{poll && (
					<div className="news-poll">
						<p className="news-poll-question">{poll.question}</p>
						{poll.options.map(option => (
							<PollOption
								key={option.optionId}
								option={option}
								totalVotes={totalVotes}
								userVotedOptionId={poll.userVotedOptionId}
								onVote={(optionId) => onVote(article.newsId, optionId)}
								expired={expired}
							/>
						))}
						{expired && <p className="news-poll-expired">Ce sondage est terminé</p>}
					</div>
				)}
			</div>
		);
	}
}

export default class News extends Component {
	constructor(props) {
		super(props);
		this.state = {
			news: [],
			loading: true,
		};
	}

	componentDidMount() {
		this.fetchNews();
	}

	getHeaders = () => ({
		'Content-Type': 'application/json',
		'id': getCookie('user'),
		'authorization': getCookie('token'),
	});

	fetchNews = async () => {
		try {
			const { data } = await axios.get(config.api + '/v2/news', { headers: this.getHeaders() });
			this.setState({ news: data, loading: false });
		} catch (err) {
			console.error('Error fetching news', err);
			this.setState({ loading: false });
		}
	}

	handleVote = async (newsId, optionId) => {
		try {
			const { data } = await axios.post(
				config.api + `/v2/news/${newsId}/poll/vote`,
				{ optionId },
				{ headers: this.getHeaders() }
			);
			// Update local state with new vote results
			this.setState(prevState => ({
				news: prevState.news.map(n => {
					if (n.newsId !== newsId || !n.poll) return n;
					return {
						...n,
						poll: {
							...n.poll,
							userVotedOptionId: data.userVotedOptionId,
							options: data.options,
						}
					};
				})
			}));
		} catch (err) {
			const msg = err.response?.data?.message || 'Erreur lors du vote';
			alert(msg);
		}
	}

	render() {
		if (!this.props.visible) return null;

		return (
			<div className="news-overlay" onClick={(e) => { if (e.target === e.currentTarget) this.props.onClose(); }}>
				<div className="news-modal">
					<div className="news-modal-header">
						<h2>Actualités</h2>
						<button className="news-modal-close" onClick={this.props.onClose}>&times;</button>
					</div>
					<div className="news-list">
						{this.state.loading ? (
							<p className="news-empty">Chargement...</p>
						) : this.state.news.length === 0 ? (
							<p className="news-empty">Aucune actualité pour le moment</p>
						) : (
							this.state.news.map(article => (
								<Article
									key={article._id}
									article={article}
									onVote={this.handleVote}
								/>
							))
						)}
					</div>
				</div>
			</div>
		);
	}
}
